'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _commonMenuItemActiveNarrow = require('./commonMenuItemActiveNarrow');

var _commonMenuItemActiveNarrow2 = _interopRequireDefault(_commonMenuItemActiveNarrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Active menu item for N and XN breakpoints
 * @constructor
 */
function SecondaryMenuItemActiveNarrow() {
  _commonMenuItemActiveNarrow2.default.prototype.constructor.apply(this, arguments);
} /**
   * @module navigation/secondaryMenuItemActiveNarrow
   * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
   */

SecondaryMenuItemActiveNarrow.prototype = (0, _create2.default)(_commonMenuItemActiveNarrow2.default.prototype);

/**
 * Set item's title
 * @param {String} title
 */
SecondaryMenuItemActiveNarrow.prototype.setTitle = function (title) {
  this.$obj.find('span:first-child').text(title);
};

exports.default = SecondaryMenuItemActiveNarrow;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/navigation/secondaryMenuItemActiveNarrow.js
// module id = 1335
// module chunks = 0